import TreeNode from "./TreeNode"
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util"

export default class DisabledNodesParentTreeNode extends TreeNode {
    constructor(idPrefix, parentId) {
        super(null, HierarchySelectorUtil.makeTreeNodeId(idPrefix, parentId));
        this.idPrefix = idPrefix;
        this.parentId = parentId;
    }

    getIdPrefix() {
        return this.idPrefix
    }

    getIdIndex() {
        return this.parentId
    }

    isCollapsible() {
        return false
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/DisabledNodesParentTreeNode.js